import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const QueryModal = ({
  open,
  onClose,
  onSubmit,
  workflowId,
  requester,
  requesterId,
}) => {
  const [notes, setNotes] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  // Access Redux state
  const workflowRoute = useSelector((state) => state.workflowRoutes || {});
  const workflowRouteActors = useSelector(
    (state) => state.workflowRoutes?.workflowRouteActors || [],
  );

  // Debug logs for initial props and state
  useEffect(() => {
    console.log("QueryModal mounted with props:", {
      workflowId,
      requester,
      requesterId,
    });
    console.log("Redux state - workflowRoute:", workflowRoute);
    console.log("Redux state - workflowRouteActors:", workflowRouteActors);
  }, []);

  // Create dropdown options with requester as first option
  const dropdownOptions = [
    {
      value: `requester-${requesterId || "default"}`,
      label: `${requester || "Requester"} (Original Requester)`,
      role: requesterId || "N/A",
    },
    ...workflowRouteActors.map((actor, index) => ({
      value: `${actor.actorRole}-${index}`,
      label: actor.actorRoleName,
      role: actor.actorRole,
    })),
  ];

  // Set default selected option when options change
  useEffect(() => {
    if (dropdownOptions.length > 0 && !selectedOption) {
      const defaultOption = dropdownOptions[0].value;
      setSelectedOption(defaultOption);
      console.log("Default option set:", defaultOption);
    }
  }, [dropdownOptions, selectedOption]);

  // Log selected option changes
  useEffect(() => {
    if (selectedOption) {
      const selectedActor = dropdownOptions.find(
        (option) => option.value === selectedOption,
      );
      console.log(
        "Current selected option:",
        selectedOption,
        "Details:",
        selectedActor,
      );
    }
  }, [selectedOption, dropdownOptions]);

  //console.log("selected: ", selectedActor.role);

  const handleOptionChange = (e) => {
    const newValue = e.target.value;
    console.log("User selected new option:", newValue);
    setSelectedOption(newValue);
  };

  const handleSubmit = () => {
    if (!selectedOption) {
      console.error("Submit attempted with no option selected");
      return;
    }

    const selectedActor = dropdownOptions.find(
      (option) => option.value === selectedOption,
    );

    console.log("Submitting query with selection:", {
      selectedOption,
      selectedActor,
      notes,
    });

    //const fullNotes = `[Query to ${selectedActor.label} (Role ID: ${selectedActor.role})]: ${notes}`;
    const fullNotes = `[Query to ${selectedActor.label} ]: ${notes}`;

    // Pass both notes and selectedActor to parent
    onSubmit({
      notes: fullNotes,
      selectedActor: selectedActor,
    });

    // Reset and close
    setNotes("");
    setSelectedOption(dropdownOptions[0]?.value || "");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Query Notes</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Notes"
          fullWidth
          multiline
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          sx={{ mb: 2 }}
        />
        <FormControl fullWidth>
          <InputLabel id="query-recipient-label">Query To:</InputLabel>
          <Select
            labelId="query-recipient-label"
            value={selectedOption}
            label="Query To:"
            onChange={handleOptionChange}
          >
            {dropdownOptions.length > 0 ? (
              dropdownOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No recipients available</MenuItem>
            )}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          disabled={!notes || !selectedOption}
          variant="contained"
        >
          Submit Query
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QueryModal;
